import styled from 'styled-components';
import { ColorConstants, FontFamilyConstants } from '@shared/constants';

export const StartIcon = styled.span`
    height: 16px;
    width: 16px;
    border-radius: 5px;
    background-color: ${props => props.backgroundColor};
    color: ${ColorConstants.white};
    font-weight: 700;
    font-size: 9px;
    font-family: ${FontFamilyConstants.Helvetica};
    display: flex;
    align-items: center;
    justify-content: center;
`;
